import BoxScoreCalculator from "../../../../sports/football/stats/box-score-calculator";
import { generateAbbreviatedTeamName } from "../../../../sports/common/utils/team-utils";

export const TeamSerializer = {
    // teamStat param would either be homeTeamStats or awayTeamStats, and would come from boxscore object (same as team param)
    serialize(team, teamStat, gameContext) {
        const { defense, kicks, offense, penalty, rushing, specialTeams } =
            teamStat?.stats || {};
        const { abbrName, teamName, teamId } = team;
        const isStartOfSecondHalf = gameContext.isStartOfSecondHalf(
            gameContext.getCurrentPeriod()
        );
        const isEndOfGame = !!gameContext.finalizeSettings;
        const isInRedZone = gameContext.isInRedZone();

        const thirdDownStats =
            BoxScoreCalculator.getThirdDownStatsByTeam(teamStat);
        const fourthDownStats =
            BoxScoreCalculator.getFourthDownStatsByTeam(teamStat);
        const assistedSackCount =
            defense.sack.completed - defense.sack.unassisted;
        const assistedTackleCount =
            defense.tackle.completed - defense.tackle.unassisted;
        const assistedTflCount =
            defense.tackleForLoss.completed - defense.tackleForLoss.unassisted;
        return {
            abbr: abbrName || generateAbbreviatedTeamName(teamName),
            conversionFourthAtt: fourthDownStats.attempted, // The amount of times a team reaches 4th down
            conversionFourthConv:
                fourthDownStats.total + fourthDownStats.touchdowns, // Times a team converted while in 4th down
            conversionThirdAtt: thirdDownStats.attempted, // The amount of times a team reaches 3rd down
            conversionThirdConv:
                thirdDownStats.total + thirdDownStats.touchdowns, // Times a team converted while in 3rd down.
            customizedName: teamName,
            defenseBlkdKick: kicks.fieldGoalBlocked.completed, // This assumes that the kick referenced, is a field goal
            defenseFumbForc: defense.fumble.forced.completed,
            defenseFumbRcvr: defense.fumble.recovered.completed,
            defensePassBrUp: defense.passBrokenUp.completed,
            defenseQbh: 0, // TODO
            defenseSackA: assistedSackCount,
            defenseSackUa: defense.sack.unassisted,
            defenseSackWinLossYards: defense.sack.totalYards,
            defenseSaf: defense.safety.completed,
            defenseTackA: assistedTackleCount,
            defenseTackUa: defense.tackle.unassisted,
            defenseTflA: assistedTflCount,
            defenseTflLossYards: defense.tackleForLoss.lostYards,
            defenseTflUa: defense.tackleForLoss.unassisted,

            /* Are these ep properties, used for PAT's? */
            epDefIfAt: 0, // TODO
            epDefKickRetAt: 0, // TODO
            epDefKickRetMd: 0, // TODO
            epDefRetMad: 0, // TODO
            epOffKickAt: kicks.patKick.attempted, // PAT Kicks Attempts
            epOffKickMd: kicks.patKick.completed, // PAT Kicks Made
            epOffPassAt: 0, // TODO
            epOffPassMd: 0, // TODO
            epOffRcvMd: 0, // TODO
            epOffRushAt: 0, // TODO
            epOffRushMd: 0, // TODO
            /********************************************/

            /* These are totals and they are assigned at the boxscore-service */
            firstDownNo: 0,
            firstDownPass: 0,
            firstDownPenalty: 0,
            firstDownRush: 0,
            /**************************************************************/

            // the stats summarizer omits the drop kick keys when none was taken
            dropKickFieldGoal: kicks.fieldGoal.dropKickCompleted || 0,
            dropKickFieldGoalAtt: kicks.fieldGoal.dropKick || 0,
            dropKickPAT: kicks.patKick.dropKickCompleted || 0,
            dropKickPATAtt: kicks.patKick.dropKick || 0,
            fumblesLost: offense.fumble.lost.completed,
            fumblesNo: offense.fumble.total.completed,
            gkRecord: "", // TODO
            keyStroke: abbrName || "",
            kickFgAtt: kicks.fieldGoal.attempted,
            kickFgBlk: kicks.fieldGoalBlocked.completed,
            kickFgLong: kicks.fieldGoal.longestYard,
            kickFgMad: kicks.fieldGoal.completed,
            kickKoNo: kicks.kickoff.completed,
            kickKoOb: 0, // TODO - I think this is kickoff out of bounds? Where is this found?
            kickKoTb: kicks.kickoff.touchback,
            kickKoDeuce: kicks.deuce.completed,
            kickKoYards: kicks.kickoff.totalYards,
            kickPunt50: 0, // TODO - What is this? I see we collect a in20 value, but not 50
            kickPuntAvg: specialTeams.punt.averageYards,
            kickPuntBlkd: specialTeams.punt.blocked.completed,
            kickPuntFc: 0, // TODO - I think this is Punt Fair Catch, where would we find this?
            kickPuntI20: specialTeams.punt.in20,
            kickPuntLong: specialTeams.punt.longestYard,
            kickPuntNo: specialTeams.punt.completed,
            kickPuntTb: specialTeams.punt.touchback,
            kickPuntYards: specialTeams.punt.totalYards,
            miscPossession: 0,
            miscYards: 0, // TODO
            name: teamName,
            partner_recipient: "", // TODO
            passAtt: offense.pass.attempted,
            passComp: offense.pass.completed,
            passInt: offense.pass.interceptions,
            passLong: offense.pass.longestYard,
            passSackYards: offense.sack.totalYards,
            passSacks: offense.sack.completed,
            passTd: offense.pass.touchdowns,
            passWinLoss: 0, // TODO
            passYards: offense.pass.totalYards,
            penaltyNo: penalty.completed,
            penaltyYards: penalty.absoluteYards,
            periodstats: [],
            players: [],
            psId: teamId,

            receivingLong: offense.passTarget.longestYard, // The longest passing yards obtained for the pass receiver. Incomplete pass does not count here.
            receivingNo: offense.passTarget.completed, // The number of received passes.
            receivingTd: offense.passTarget.touchdowns, // Increments by one if a pass play ended in a touchdown
            receivingYards: offense.passTarget.totalYards, // This is the summatory of receiving yards. Gained and Lose yards.

            recipient_active: "n", // TODO
            record: team.conferenceRecord
                ? `${team.overallRecord || ""}, ${team.conferenceRecord}`
                : team.overallRecord || "",
            record_conf: team.conferenceRecord || "",
            record_gen: "", // TODO

            /********************************/
            redZoneEndOfGame: isInRedZone && isEndOfGame,
            redZoneEndOfHalf: isInRedZone && isStartOfSecondHalf,
            redZoneEndOnDowns: 0, // TODO
            redZoneEndOnFga: 0, // TODO
            redZoneEndOnFumble: 0, // TODO
            redZoneEndOnIntCpt: 0, // TODO
            redZoneFgsMade: kicks.fieldGoalRedzone.completed,
            redZoneOnSideAttempt: 0, // TODO
            redZoneOnSideRecover: 0, // TODO
            redZonePassingTds: 0, // TODO
            redZonePointsScored: 0, // TODO
            redZoneRushingTds: 0, // TODO
            redZoneTimeInside20: 0, // TODO
            redZoneTimeScored: 0, // TODO
            /******************************************************************/

            returnsFumbLong: defense.fumble.returned.longestYard,
            returnsFumbNo: defense.fumble.returned.completed,
            returnsFumbTd: defense.fumble.returned.touchdowns,
            returnsFumbYards: defense.fumble.returned.totalYards,
            returnsIntLong: defense.interceptionReturns.longestYard,
            returnsIntNo: defense.interceptionReturns.completed,
            returnsIntTd: defense.interceptionReturns.touchdowns,
            returnsIntYards: defense.interceptionReturns.totalYards,
            returnsKickLong: kicks.kickoffReturn.longestYard,
            returnsKickNo: kicks.kickoffReturn.completed,
            returnsKickTd: kicks.kickoffReturn.touchdowns,
            returnsKickYards: kicks.kickoffReturn.totalYards,
            returnsPuntLong: kicks.kickoffReturn.longestYard,
            returnsPuntNo: specialTeams.puntReturn.completed,
            returnsPuntTd: specialTeams.puntReturn.touchdowns,
            returnsPuntYards: specialTeams.puntReturn.totalYards,
            rpi: {}, // TODO
            rushAtt: offense.rush.attempted,
            rushLong: offense.rush.longestYard,
            rushTd: offense.rush.touchdowns,
            rushWinLoss: 0, // TODO
            rushYards: offense.rush.totalYards,
            totalOffPlays: offense.total.gainedPlays,
            totalOffYards: offense.total.gainedYards
        };
    }
};
